import React from "react";
import { observer } from "mobx-react";
import { dataSearchState } from "../state";
import { verifyBulkActionPerformedAndAllow } from "../DataSearchUtils";
import IncludeExcludeAccordion from "./IncludeExcludeAccordion";

/** The provider's 48 contact language values (AI-Ark contact.language), in its documented order. */
export const LANGUAGE_IDS = [
  "english", "spanish", "french", "portuguese", "german", "dutch", "italian", "chinese", "turkish", "polish",
  "russian", "swedish", "arabic", "indonesian", "danish", "czech", "norwegian", "japanese", "korean", "romanian",
  "ukrainian", "thai", "hindi", "malay", "tagalog", "vietnamese", "finnish", "persian", "greek", "hungarian",
  "bengali", "marathi", "telugu", "panjabi", "serbian", "slovak", "croatian", "lithuanian", "latvian", "albanian",
  "icelandic", "armenian", "bosnian", "tamil", "javanese", "malayalam", "kannada", "burmese"
];

const LANGUAGE_LABELS = { panjabi: "Punjabi" };
export const languageLabel = id => LANGUAGE_LABELS[id] || String(id).charAt(0).toUpperCase() + String(id).slice(1);

const LANGUAGE_ITEMS = LANGUAGE_IDS.map(id => ({ id, label: languageLabel(id) })).sort((a, b) =>
  a.label.localeCompare(b.label)
);

const COUNT_OPTIONS = [2, 3, 4, 5];

/** Languages the person speaks (include / exclude) and how many languages they speak. */
const LanguageFilterPanel = observer(() => {
  const { languageCountMin } = dataSearchState.filterComponentData || {};

  const setCount = value => {
    const performAction = () =>
      dataSearchState.setFilterComponentData({
        ...dataSearchState.filterComponentData,
        languageCountMin: value === "" ? null : Number(value)
      });
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performAction);
    } else {
      performAction();
    }
  };

  return (
    <>
      <div className="languageCountRow">
        <span className="languageCountLabel">Languages spoken</span>
        <select
          className="employeesByDeptRangeInput languageCountSelect"
          value={languageCountMin ?? ""}
          onChange={e => setCount(e.target.value)}
        >
          <option value="">Any number</option>
          {COUNT_OPTIONS.map(n => (
            <option key={n} value={n}>
              {n} or more
            </option>
          ))}
        </select>
      </div>
      <IncludeExcludeAccordion
        includeKey="language"
        excludeKey="languageExclude"
        items={LANGUAGE_ITEMS}
        searchPlaceholder="Search languages"
        emptyLabel="languages"
      />
    </>
  );
});

export default LanguageFilterPanel;
